<template>
    <DefaultLayout>
        <DefaultHeader :showHeader=true :language="this.lang" />
        <div id="content" class="container">
            <div v-if="this.showForm == true" class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 center-block" id="step2">
                    <div class="well no-padding">
                        <form id="sharpForm" class="smart-form client-form" novalidate @submit.prevent="submit">
                            <header>
                                {{ labels.headerText }}
                            </header>
                            <fieldset id="sharpFormFieldSet">
                                <legend>
                                    Welcome <strong>
                                        <span id="employeeName">{{store.firstName}} {{store.lastName}}</span>
                                    </strong>!
                                </legend>
                                <section>
                                    <div v-if="this.error.length > 0" class="error-msg fade in">
                                        {{ this.error }}
                                    </div>
                                </section>
                                <section>
                                    <label class="label">{{ labels.supervisor}} </label>
                                    <label class="input">
                                        <input class="form-control" v-model="supervisor" type="text" readonly>
                                    </label>
                                </section>
                                <section>
                                    <label class="label">{{ labels.branch }}<span class="tps-danger">  *</span></label>
                                    <label class="select">
                                        <select class="form-control" v-model="selBranchName" @change="onChangeBranch">
                                            <option v-for="item in this.branches" :value="item.branchName" :key="item.branchName">
                                                {{ item.branchName }}
                                            </option>
                                        </select>
                                        <span class="alert-danger" v-if="v$.selBranchName.$error"> {{  v$.selBranchName.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="label">{{  labels.department }}<span class="tps-danger">  *</span></label>
                                    <label class="select">
                                        <select class="form-control" v-model="selBranchLocationId">
                                            <option v-for="item in this.branchLocations" :value="item.id" :key="item.id">
                                                {{ item.Name }}
                                            </option>
                                        </select>
                                        <span class="alert-danger" v-if="v$.selBranchLocationId.$error"> {{  v$.selBranchLocationId.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="input">{{ labels.area }}</label>
                                    <label class="input">
                                        <input class="form-control" v-model="area" type="text">
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="input">{{ labels.equipment }}</label>
                                    <label class="input">
                                        <input class="form-control" v-model="equipment" type="text">
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="input">{{ labels.dateOfEvent }}<span class="tps-danger">  *</span></label>
                                    <label class="input">
                                        <input class="form-control" type="date" v-model="dateSubmitted">
                                        <span class="alert-danger" v-if="v$.dateSubmitted.$error"> {{  v$.dateSubmitted.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="input">{{ labels.timeOfEvent }}<span class="tps-danger">  *</span></label>
                                    <label class="input">
                                        <input class="form-control" type="time" v-model="timeSubmitted">
                                        <span class="alert-danger" v-if="v$.timeSubmitted.$error"> {{  v$.timeSubmitted.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="label">{{ labels.category }}<span class="tps-danger">  *</span></label>
                                    <label class="select">
                                        <select class="form-control" v-model="selCategoryId" @change="onChangeCategory" data-msg-required="Please select what you saw.">
                                            <option v-for="item in this.categories" :value="item.id" :key="item.id">
                                                {{ item.categoryName }}
                                            </option>
                                        </select>
                                        <span class="alert-danger" v-if="v$.selCategoryId.$error"> {{  v$.selCategoryId.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="input">{{ labels.categoryDesc }}</label>
                                    <label class="input">
                                        <textarea type="text" v-model="categoryDesc" rows="3" class="form-control" readonly></textarea>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="label">{{ labels.nearMiss }}<span class="tps-danger">  *</span></label>
                                    <label class="select">
                                        <select v-if="this.lang == 'en'" class="form-control" v-model="nearMiss" data-msg-required="Please select near miss or not.">
                                            <option>Yes</option>
                                            <option>No</option>
                                        </select>
                                        <select v-if="this.lang != 'en'" class="form-control" v-model="nearMiss" data-msg-required="Por favor seleccione casi accidente o no.">
                                            <option>Sí</option>
                                            <option>No</option>
                                        </select>
                                        <span class="alert-danger" v-if="v$.nearMiss.$error"> {{  v$.nearMiss.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="label">{{ labels.nearMissType }}<span v-if="this.nearMiss === 'Yes'" class="tps-danger">  *</span></label>
                                    <label class="select">
                                        <select v-if="this.lang == 'en'" :disabled="!isNearMissTypeEnabled" class="form-control" v-model="nearMissType" data-msg-required="Please select a type of near miss">
                                            <option :value="'Burn'">Burn</option>
                                            <option :value="'Caught in/Under/Between'">Caught in/Under/Between</option>
                                            <option :value="'Chemical Exposure'">Chemical Exposure</option>
                                            <option :value="'Cut/Puncture'">Cut/Puncture</option>
                                            <option :value="'Driver error'">Driver error</option>
                                            <option :value="'Electrocution'">Electrocution</option>
                                            <option :value="'Fire'">Fire</option>
                                            <option :value="'Heat Exposure'">Heat Exposure</option>
                                            <option :value="'Housekeeping'">Housekeeping</option>
                                            <option :value="'Miss handling pipe'">Miss handling pipe</option>
                                            <option :value="'Other'">Other</option>
                                            <option :value="'Previous Employer WC Claim'">Previous Employer WC Claim</option>
                                            <option :value="'Road Condition'">Road Condition</option>
                                            <option :value="'Slip/Trip/Fall'">Slip/Trip/Fall</option>
                                            <option :value="'Sprain/Strain'">Sprain/Strain</option>
                                            <option :value="'Struck By'">Struck By</option>
                                            <option :value="'Unsafe Act/Condition'">Unsafe Act/Condition</option>
                                        </select>
                                        <select v-if="this.lang != 'en'" :disabled="!isNearMissTypeEnabled" class="form-control" v-model="nearMissType" data-msg-required="Por favor seleccione un tipo de cuasi accidente">
                                            <option :value="'Burn'">Burn</option>
                                            <option :value="'Caught in/Under/Between'">Atrapado en/Menos/Entre</option>
                                            <option :value="'Chemical Exposure'">Exposición química</option>
                                            <option :value="'Cut/Puncture'">Corte/perforación</option>
                                            <option :value="'Driver error'">error del controlador</option>
                                            <option :value="'Electrocution'">Electrocución</option>
                                            <option :value="'Fire'">Fuego</option>
                                            <option :value="'Heat Exposure'">Exposición al calor</option>
                                            <option :value="'Housekeeping'">Gestión interna</option>
                                            <option :value="'Miss handling pipe'">Tubería de manipulación fallida</option>
                                            <option :value="'Other'">Otra</option>
                                            <option :value="'Previous Employer WC Claim'">Reclamo anterior de WC del empleador</option>
                                            <option :value="'Road Condition'">Estado de la carretera</option>
                                            <option :value="'Slip/Trip/Fall'">Resbalón/tropez/caída</option>
                                            <option :value="'Sprain/Strain'">Esguince/distensión</option>
                                            <option :value="'Struck By'">Golpeado por</option>
                                            <option :value="'Unsafe Act/Condition'">Acto/Condición Insegura</option>
                                        </select>
                                        <span class="alert-danger" v-if="v$.nearMissType.$error"> {{  v$.nearMissType.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="textarea">{{ labels.desc }}<span class="tps-danger">  *</span></label>
                                    <label class="textarea">
                                        <textarea type="text" v-model="desc" rows="3" class="form-control"></textarea>
                                        <span class="alert-danger" v-if="v$.desc.$error"> {{  v$.desc.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <label class="textarea">{{ labels.correctiveAction }}<span class="tps-danger">  *</span></label>
                                    <label class="textarea">
                                        <textarea type="text" v-model="correctiveAction" rows="3" class="form-control"></textarea>
                                        <span class="alert-danger" v-if="v$.correctiveAction.$error"> {{  v$.correctiveAction.$errors[0].$message }}</span>
                                        <span class="help-block"></span>
                                    </label>
                                </section>
                                <section>
                                    <button type="submit" class="btn btn-success btn-lg btn-block" :disabled="isSubmitting">
                                        Next&nbsp;<font-awesome-icon icon="arrow-right" />
                                    </button>
                                </section>
                            </fieldset>
                            <fieldset class="loader center-block hidden" id="myLoader">
                                <div class="center-block"></div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
            <div v-if="this.showForm == false" class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 center-block">
                    <div class="well no-padding">
                        <form class="smart-form client-form">
                            <header>
                                {{ this.headerText }}
                            </header>
                            <fieldset>
                                <section>
                                    <h1 class="font-400">Thank you.</h1>
                                </section>
                                <section>
                                    <button class="btn btn-success btn-lg btn-block btn-info" @click="(event) => enterAnotherSHARP(event)">
                                        <span v-if="this.lang == 'en'">Enter another SITE Focus Observation</span>
                                        <span v-if="this.lang == 'es'">Ingrese otra observación de SITE Focus</span>
                                    </button>
                                </section>
                                <section>
                                    <router-link v-if="this.lang == 'en'" to="/" class="btn btn-success btn-lg btn-block btn-info">DONE</router-link>
                                    <router-link v-if="this.lang == 'es'" to="/" class="btn btn-success btn-lg btn-block btn-info">TERMINADO</router-link>
                                </section>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </DefaultLayout>
</template>
<script src="./SharpEntry.js"></script>